import type { ReactNode } from 'react';

interface ImagePanelProps {
    children: ReactNode;
    img: {
        src: string;
        alt: string;
    };
    className?: string;
    hideImageOnSmallScreens?: boolean;
}

export const ImagePanel = ({ children, img, className, hideImageOnSmallScreens = false }: ImagePanelProps) => (
    <div className={`flex flex-col rounded-16 border ${className || ''}`}>
        <div className={`w-full overflow-hidden rounded-t-16 aspect-video ${hideImageOnSmallScreens ? 'hidden md:block' : ''}`}>
            <img className="w-full h-full object-cover s-bg-subtle block text-center bg-center" src={img.src} alt={img.alt} />
        </div>
        <div className="p-16 md:p-24 gap-y-16 flex flex-col">{children}</div>
    </div>
);
